import { usePage } from '@inertiajs/react';
import type { ReactNode } from 'react';
import { ImpersonationBanner } from '@/components/admin/ImpersonationBanner';
import { MentorSidebar } from '@/components/mentor/MentorSidebar';

// The persistent shell of every mentor portal page — the port of the two
// src/components/mentor/protected-layout-26-{co,mx}.tsx twins as one component
// (PORTING.md G5). Both wear the ph26 palette and always show their sidebar; the only
// thing that differed, the edition, comes from the `mentorPortal` shared prop.
//
// It takes only `children`: an Inertia layout function is called twice and the first call
// gets the raw page props, so anything it destructures from an argument blows up. It is
// also inert without its shared prop, because `entrypoints/inertia.ts` assigns it to the
// whole `Mentor/` name prefix (U9).
export function MentorPortalLayout({ children }: { children: ReactNode }) {
  const { mentorPortal, auth } = usePage().props;

  if (!mentorPortal) {
    return <>{children}</>;
  }

  return (
    <div className="theme-ph26 selection-on-light flex h-screen flex-col overflow-hidden bg-background text-foreground">
      <ImpersonationBanner
        impersonatedBy={mentorPortal.impersonatedBy}
        userName={auth.user?.name ?? null}
        userEmail={auth.user?.email ?? null}
      />
      <div className="flex flex-1 overflow-hidden">
        <div className="hidden w-64 md:block">
          <MentorSidebar
            edition={mentorPortal.edition}
            mentor={mentorPortal.mentor}
            discordGuildId={mentorPortal.discordGuildId}
            discordFaqChannelId={mentorPortal.discordFaqChannelId}
          />
        </div>
        <main className="flex-1 overflow-y-auto bg-background">{children}</main>
      </div>
    </div>
  );
}
